import React, { useEffect } from 'react'
import styled from 'styled-components'

export default function Switch({
  onChange = () => {},
  value,
  defaultValue = '7D',
  options = ['7D', '1M'],
}) {
  const [innerValue, setValue] = React.useState(
    value || defaultValue || options[0]
  )
  const ref = React.useRef(null)
  const [childrenWidths, setChildrenWidths] = React.useState([])

  const handleChange = newValue => {
    onChange(newValue)
    if (!value) {
      setValue(newValue)
    }
  }

  useEffect(() => {
    if (ref.current) {
      const children = ref.current.children
      const widths = Array.from(children)
        .filter(el => !el.classList.contains('ignore'))
        .map(child => child.offsetWidth)
      setChildrenWidths(widths)
    }
  }, [ref.current])
  return (
    <>
      <input type="text" defaultValue={'7D'} hidden />
      <CheckboxWrapper ref={ref}>
        <MovingBackground
          className="ignore"
          data-current={value || innerValue}
          options={options}
          sizes={childrenWidths}
        >
          {value || innerValue}
        </MovingBackground>
        {options.map((option, index) => (
          <Option key={index} onClick={() => handleChange(option)}>
            {option}
          </Option>
        ))}
      </CheckboxWrapper>
    </>
  )
}

const CheckboxWrapper = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  border-radius: 999px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: #f9f9f9;
  position: relative;
  cursor: pointer;
  user-select: none;
`

const Option = styled.div`
  display: flex;
  height: 24px;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #0091ff;
  border-radius: 28px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  z-index: 1;
`

const MovingBackground = styled.div`
  display: flex;
  height: 24px;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 28px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: #fff;
  color: #fff;
  position: absolute;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
  ${({ options, sizes }) => `
  &[data-current='${options[0]}'] {
    transform: translateX(0);
  }

  &[data-current='${options[1]}'] {
    transform: translateX(${sizes[0] - 2}px);
  }
  `}
`
